import React from 'react';
import { DynamicQRGenerator } from '../components/qr/DynamicQRGenerator';
import { SEOHead } from '../components/seo/SEOHead';

export const DynamicQRGeneratorPage: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Create Dynamic QR Code | FreeQRCodeNow"
        description="Create dynamic QR codes with live preview and customization. Change the destination URL anytime without regenerating the QR code."
      />

      <div className="max-w-7xl mx-auto">
        <DynamicQRGenerator />
      </div>
    </>
  );
};

